module.exports = __webpack_public_path__ + "static/media/r&d_i.8c532987.jpg";